import React from "react";
import {SimpleGrid, Box, Skeleton, Stack} from "@chakra-ui/core";

const LoadingScreen: React.FC = () => (
  <Box height="100%" overflowY="hidden">
    <Box padding={{base: 3, sm: 6}}>
      <Stack isInline marginBottom={{base: 3, sm: 6}} spacing={{base: 3, sm: 6}}>
        <Skeleton height="48px" width="200px" />
        <Skeleton height="48px" width="200px" />
      </Stack>
      <SimpleGrid minChildWidth="320px" spacing={{base: 3, sm: 6}}>
        {Array(12)
          .fill(true)
          .map((_, index) => (
            <Box key={index} borderWidth="1px" overflow="hidden" rounded="lg">
              <Skeleton height="140px" mb={4} />
              <Box p={6}>
                <Skeleton height="20px" mb={2} />
                <Skeleton height="20px" mb={6} />
                <Skeleton height="40px" width={["100%", "160px"]} />
              </Box>
            </Box>
          ))}
      </SimpleGrid>
    </Box>
  </Box>
);

export default LoadingScreen;
